export const CALL_NUMBER_BROWSE_COLUMNS = {
  ID: 'id',
  NAME: 'name',
  TYPE_IDS: 'typeIds',
  SHELVING_ALGORITHM: 'shelvingAlgorithm',
};
